import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import LoadThemeComponent from '../../../../base/LoadThemeComponent';
import trackQuickPickButtonClicked from '../../../../base/trackers/helpers';

import NumberPanelTitle from '../../Lottery/picker/NumberPanelTitle';

import NumberPanel from './NumberPanel';

import DivButton, { createInteractiveProps } from 'components/common/DivButton';
import { LineProps } from 'components/play/Types/Types';
import { PRIMARY_NUMBERS, isValidLine } from 'components/play/helpers/linesHelper';
import useLinesHelper from 'components/play/helpers/useLinesHelper';
import { RootState } from 'components/play/redux/store';
import { numberArray } from 'utils/helpers';

export default function Line({ lineNumbers, lineIndex, stake = 1 }: LineProps) {
    const { t } = useTranslation();
    const { numbersToPlay } = useSelector((state: RootState) => state.kenoPlayStore);
    const { lottery, setRandomLine, removeLine } = useLinesHelper();
    const [selectSignal, setSelectSignal] = useState<{ number?: number }>({});

    const checked = isValidLine(lottery, lineNumbers, [numbersToPlay]);

    const renderPickerUncheckedView = () => (
        <div className="row purchase-line-container-mobile fade-in">
            <div className="title-container position-relative g-0">
                <h1 className="title text-center">
                    <NumberPanelTitle />
                </h1>
            </div>
            <div className="row-balls-container d-flex flex-column  ">
                <div className={`mobile-new-line unchecked d-flex flex-wrap justify-content-center ${numbersToPlay > 6 ? "balls-compact" : ""}`}>
                    {numberArray(numbersToPlay).map((i) => {
                        const number = lineNumbers[PRIMARY_NUMBERS]?.[i];

                        return (
                            <DivButton
                                key={i}
                                className="ball"
                                onClick={() => setSelectSignal({ number: number ?? 0 })}
                            >
                                {number}
                            </DivButton>
                        );
                    })}
                </div>
                <button
                    type="button"
                    onClick={() => setRandomLine(lineIndex)}
                    className="btn btn-primary button quick-pick-mobile mx-auto"
                >
                    {t('playPicker.quickPick')}
                </button>
            </div>
        </div>
    );

    const renderPickerCheckedView = () => (
        <div className="row purchase-line-container-mobile fade-in mobile-picker-checked">
            <div className={`row-balls-container checked d-flex flex-row justify-content-between align-items-center g-0 w-auto position-relative ${
                numbersToPlay > 6 ? "balls-compact" : ""
            }`}>
                <div className="mobile-new-line d-flex flex-wrap">
                    {numberArray(numbersToPlay).map((i) => {
                        const number = lineNumbers[PRIMARY_NUMBERS]?.[i];

                        return (
                            <DivButton
                                key={i}
                                className="ball"
                                onClick={() => setSelectSignal({ number: number ?? 0 })}
                            >
                                {number}
                            </DivButton>
                        );
                    })}
                </div>
            </div>
            <div className="row-balls-container-right w-auto g-0 position-relative">
                <i
                    className="fas fa-trash mobile-delete-line"
                    {...createInteractiveProps(() => removeLine(lineIndex))}
                    aria-label={t('playPicker.clear')}
                />
            </div>
        </div>
    );
    const baseView = () => (
        <div className={`keno-line row align-items-center justify-content-between ${checked ? 'checked' : ''}`}>
            <NumberPanel
                selectSignal={selectSignal}
                lineNumbers={lineNumbers}
                lineIndex={lineIndex}
                checked={checked}
                stake={stake}
            />
            <div className="col-12 col-xl-2 line-title">
                {checked ? (
                    <span className="title title-ok">{t('playPicker.ok')}</span>
                ) : (
                    <span className="title">
                        {t(`playPicker.${numbersToPlay > 1 ? 'pickNNumbers' : 'pickOneNumber'}`, {
                            numbersToPick: numbersToPlay,
                        })}
                    </span>
                )}
            </div>
            <div className="col row justify-content-lg-start justify-content-center">
                {numberArray(numbersToPlay).map((i) => {
                    const number = lineNumbers[PRIMARY_NUMBERS]?.[i];

                    return (
                        <DivButton key={i} className="ball" onClick={() => setSelectSignal({ number: number ?? 0 })}>
                            {number}
                        </DivButton>
                    );
                })}
            </div>
            <div className="col-12 col-md-3 col-xl-2 mt-4 mt-md-0 row row-buttons no-gutters">
                <div>
                    <button
                        type="button"
                        onClick={() => {
                            setRandomLine(lineIndex);
                            trackQuickPickButtonClicked(lottery.slug);
                        }}
                        className="btn btn-primary quick-pick"
                    >
                        {t('playPicker.quickPick')}
                    </button>
                </div>
                <div>
                    <button
                        type="button"
                        onClick={() => removeLine(lineIndex)}
                        className="btn btn-secondary purchase-line-clear"
                    >
                        {t('playPicker.clear')}
                    </button>
                </div>
            </div>
        </div>
    );

    const defaultView = () => (
        <>
            {lineNumbers[PRIMARY_NUMBERS].length > 0 ? renderPickerCheckedView() : renderPickerUncheckedView()}
            <NumberPanel
                selectSignal={selectSignal}
                lineNumbers={lineNumbers}
                lineIndex={lineIndex}
                checked={checked}
                stake={stake}
            />
        </>
    );
    return <LoadThemeComponent defaultView={defaultView} baseView={baseView} />;
}
